<template>
  <span class="thum-img thum-package">
    <ul>
      <li v-for="(item, index) in packageList" :key="index">
        <div class="cell-img" @click.prevent="()=>moveToContent(item)">
          <img v-lazy="getLazyLoadObj(item)" alt=""/>
           <age-tag :age-code="item.targetage" content-type="mypooq"></age-tag>
        </div>
      </li>
    </ul>
  </span>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import { get } from 'lodash'
import { resizeThumbnail } from '@/common/image.filter'
import AgeTag from '@/components/tags/AgeTag'
import utils from '@/common/util/utils'

export default {
  name: 'VoucherPackage',
  components: {
    AgeTag
  },
  props: ['packageListInfo', 'own'],
  data () {
    return {
      offset: 0,
      limit: 20,
      isDeleteMode: false,
      endOfList: false,
      showEmptyList: false,
      packageList: [],
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    moveToContent (item) {
      if (this.device === 'mobile') {
        this.$router.push(`/player/movie?movieid=${item.movieid}`)
      } else {
        location.href = 'captvpooq://player/movie?movieid=' + item.movieid
      }
    },
    setData () {
      MyPooqService.myPurchaseContentPackageDetail({
        productid: this.packageListInfo.productid, contenttype: 'movie', offset: 0, limit: 50
      }).then(({ data }) => {
        this.packageList = get(data, ['0', 'list'], [])
      })
    },
    getLazyLoadObj (packageItem) {
      return {
        src: resizeThumbnail(packageItem.image, { width: 340, height: 480, quality: 75, multiply: 3 }),
        error: '/img/common/img_default_thum_1.png',
        loading: '/img/common/img_default_thum_1.png'
      }
    }
  },
  created () {
    this.setData()
  }
}
</script>

<style scoped>
.cell-img img {
  height: 120px;
}
</style>
